module.exports = __webpack_public_path__ + "static/media/details-19-image-3.f552ef89.jpg";